// ADR-134: how a background run started, worded and coloured the same way in
// every run report (Ingestion Sync Runs, Direct Representative Discrepancy Audit).
import { describeTrigger } from './ingestionSyncRuns';
import { SYNC_TRIGGER_COLORS } from '../constants/ingestionSyncRuns';

/** 'manual' / 'MANUAL' → 'MANUAL'; 'scheduler' / 'SCHEDULER' / missing → 'SCHEDULER'; 'API' kept. */
export const toTriggerKey = (value) => {
  const key = String(value || 'SCHEDULER').toUpperCase();
  return key === 'MANUAL' || key === 'API' ? key : 'SCHEDULER';
};

/** "Scheduled" / "Manual · ops@x.com" for a run carrying triggeredBy + triggeredByUser. */
export const describeRunTrigger = (run) => describeTrigger({
  trigger: toTriggerKey(run?.triggeredBy),
  triggeredByUser: run?.triggeredByUser,
});

/** Inline style: muted when scheduled (none), amber when started by hand. */
export const runTriggerStyle = (run) => {
  const color = SYNC_TRIGGER_COLORS[toTriggerKey(run?.triggeredBy)];
  return color ? { color } : undefined;
};
